var _rect, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _circle1, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _circle35, _circle36, _circle37, _circle38, _line, _line2, _line3, _line4, _line5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMeasure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 5,
    fill: "#2B9A99",
    fillOpacity: 0.24
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.0938,
    cy: 13.6187,
    r: 2.43855,
    fill: "#2B9A99"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.0938,
    cy: 13.6187,
    r: 2.43855,
    fill: "#2B9A99"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.0938,
    cy: 13.6187,
    r: 2.43855,
    fill: "#2B9A99"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.0938,
    cy: 13.6187,
    r: 2.43855,
    fill: "#2B9A99"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.0938,
    cy: 13.6187,
    r: 2.43855,
    stroke: "#2B9A99",
    strokeWidth: 0.360388
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.0843,
    cy: 26.0467,
    r: 2.42904,
    fill: "#2B9A99"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.0843,
    cy: 26.0467,
    r: 2.42904,
    fill: "#2B9A99"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.0843,
    cy: 26.0467,
    r: 2.42904,
    fill: "#2B9A99"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.0843,
    cy: 26.0467,
    r: 2.42904,
    fill: "#2B9A99"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.0843,
    cy: 26.0467,
    r: 2.42904,
    stroke: "#2B9A99",
    strokeWidth: 0.360388
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 35.5594,
    cy: 26.0467,
    r: 2.42904,
    fill: "#2B9A99"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 35.5594,
    cy: 26.0467,
    r: 2.42904,
    fill: "#2B9A99"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 35.5594,
    cy: 26.0467,
    r: 2.42904,
    fill: "#2B9A99"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 35.5594,
    cy: 26.0467,
    r: 2.42904,
    fill: "#2B9A99"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 35.5594,
    cy: 26.0467,
    r: 2.42904,
    stroke: "#2B9A99",
    strokeWidth: 0.360388
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.6092,
    cy: 26.0467,
    r: 2.42904,
    fill: "#2B9A99"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.6092,
    cy: 26.0467,
    r: 2.42904,
    fill: "#2B9A99"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.6092,
    cy: 26.0467,
    r: 2.42904,
    fill: "#2B9A99"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.6092,
    cy: 26.0467,
    r: 2.42904,
    fill: "#2B9A99"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.6092,
    cy: 26.0467,
    r: 2.42904,
    stroke: "#2B9A99",
    strokeWidth: 0.360388
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 35.5594,
    cy: 13.6092,
    r: 2.42904,
    fill: "#2B9A99"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 35.5594,
    cy: 13.6092,
    r: 2.42904,
    fill: "#2B9A99"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 35.5594,
    cy: 13.6092,
    r: 2.42904,
    fill: "#2B9A99"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 35.5594,
    cy: 13.6092,
    r: 2.42904,
    fill: "#2B9A99"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 35.5594,
    cy: 13.6092,
    r: 2.42904,
    stroke: "#2B9A99",
    strokeWidth: 0.360388
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.6092,
    cy: 13.6092,
    r: 2.42904,
    fill: "#2B9A99"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.6092,
    cy: 13.6092,
    r: 2.42904,
    fill: "#2B9A99"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.6092,
    cy: 13.6092,
    r: 2.42904,
    fill: "#2B9A99"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.6092,
    cy: 13.6092,
    r: 2.42904,
    fill: "#2B9A99"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.6092,
    cy: 13.6092,
    r: 2.42904,
    stroke: "#2B9A99",
    strokeWidth: 0.360388
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 35.5594,
    cy: 36.5233,
    r: 2.42904,
    fill: "#2B9A99"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 35.5594,
    cy: 36.5233,
    r: 2.42904,
    fill: "#2B9A99"
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: 35.5594,
    cy: 36.5233,
    r: 2.42904,
    fill: "#2B9A99"
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: 35.5594,
    cy: 36.5233,
    r: 2.42904,
    fill: "#2B9A99"
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: 35.5594,
    cy: 36.5233,
    r: 2.42904,
    stroke: "#2B9A99",
    strokeWidth: 0.360388
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.6092,
    cy: 36.5233,
    r: 2.42904,
    fill: "#2B9A99"
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.6092,
    cy: 36.5233,
    r: 2.42904,
    fill: "#2B9A99"
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.6092,
    cy: 36.5233,
    r: 2.42904,
    fill: "#2B9A99"
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.6092,
    cy: 36.5233,
    r: 2.42904,
    fill: "#2B9A99"
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.6092,
    cy: 36.5233,
    r: 2.42904,
    stroke: "#2B9A99",
    strokeWidth: 0.360388
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 25.3989,
    y1: 12.3086,
    x2: 25.3989,
    y2: 24.093,
    stroke: "#2B9A99",
    strokeWidth: 0.610371
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 14.9233,
    y1: 24.75,
    x2: 14.9233,
    y2: 36.5344,
    stroke: "#2B9A99",
    strokeWidth: 0.610371
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 35.874,
    y1: 24.0898,
    x2: 35.874,
    y2: 35.8742,
    stroke: "#2B9A99",
    strokeWidth: 0.610371
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 34.2593,
    y1: 26.3638,
    x2: 15.928,
    y2: 26.3638,
    stroke: "#2B9A99",
    strokeWidth: 0.610371
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 34.2593,
    y1: 13.9263,
    x2: 15.928,
    y2: 13.9263,
    stroke: "#2B9A99",
    strokeWidth: 0.610371
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeasure);
export default __webpack_public_path__ + "static/media/measure.92054f81442b9fccdacbd85dcb6122ad.svg";
export { ForwardRef as ReactComponent };